import { addMinutes, formatISO, subMinutes } from "date-fns";

import { DecisionEnvironment } from "src/clients/history_v3";
import { NODE_TYPE } from "src/constants/NodeTypes";
import { JobRun, JobRunStatusType } from "src/jobs/types";
import { useNodeStatusCounts } from "src/performance/queries";
import { useAuthoringContext } from "src/router/routerContextHooks";
import { useGraphStore } from "src/store/StoreProvider";

export const useJobRunNodeStatusCounts = (jobRun: JobRun) => {
  const { workspace, flow } = useAuthoringContext();
  const { selectedNode } = useGraphStore();

  const isJobRunning =
    jobRun.status.type === JobRunStatusType.Running ||
    jobRun.status.type === JobRunStatusType.Writing;

  const { data: nodeStatusCounts } = useNodeStatusCounts({
    baseUrl: workspace.base_url ?? "",
    jobRunId: jobRun.id,
    flowId: flow.id,
    environment: DecisionEnvironment.TEST,
    fromStartTime: formatISO(subMinutes(new Date(jobRun.created_at), 60)),
    untilStartTime: formatISO(addMinutes(new Date(jobRun.updated_at), 60)),
    isRunning: isJobRunning,
  });

  const selectedNodeCounts = selectedNode?.id
    ? nodeStatusCounts?.status_counts[selectedNode.id]
    : undefined;

  const isOutputNode = selectedNode?.type === NODE_TYPE.OUTPUT_NODE;

  return {
    isJobRunning,
    isOutputNode,
    successCount: isOutputNode
      ? (jobRun.success_rows_count ?? 0)
      : (selectedNodeCounts?.success ?? 0),
    failureCount: isOutputNode
      ? (jobRun.failed_rows_count ?? 0)
      : (selectedNodeCounts?.failed ?? 0),
    ignoredCount: isOutputNode ? (jobRun.ignored_rows_count ?? 0) : 0,
  };
};
